import { render, staticRenderFns } from "./taskcenter.vue?vue&type=template&id=128426bb&scoped=true&"
import script from "./taskcenter.vue?vue&type=script&lang=js&"
export * from "./taskcenter.vue?vue&type=script&lang=js&"
import style0 from "./taskcenter.vue?vue&type=style&index=0&id=128426bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128426bb",
  null
  
)

export default component.exports